export enum E_CertificateTypes {
  Pyaterochka = 'pyaterochka',
  Magnit = 'magnit',
  Vkusvill = 'vkusvill',
}

// Статус пайщика для пользователя
export enum E_ShareholderStatuses {
  None = 0, // Только зарегистрировался
  Want = 5, // Заполнил и отправил форму
  Waiting = 10, // Произвел оплату членского взноса и ожидает подтверждения
  Shareholder = 15, // Стал пайщиком
  Subscription1 = 30, // Приобрёл тариф №1
  Subscription2 = 50, // Приобрёл тариф №2
  Subscription3 = 70, // Приобрёл тариф №3
}

export enum E_CheckStatus {
  NEW = 'new',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}
